import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import ColorWheelIconSvg from '../../../../../images/svg/icons8-color-wheel';
import { HEX_OR_RGB_TEXT, PRIMARY_COLOR_TEXT } from './website-form.texts';

interface IProps {
    value: string;
    normalizedValue: string;
    validationError: string;
    onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    intl: IntlShape;
}

export const WebsitePrimaryColor = injectIntl((props: IProps) => {
    return (
        <div>
            <label className='oe-form-field__title'>
                {props.intl.formatMessage(PRIMARY_COLOR_TEXT)}
            </label>
            <div className='flex w-100 p-top-2px'>
                <input
                    className='oe-form-field__control m-right-11px text-blue font-700'
                    type='text'
                    placeholder={props.intl.formatMessage(HEX_OR_RGB_TEXT)}
                    value={props.value || ''}
                    onChange={props.onChange}
                />
                <label className='flex center cursor-point'>
                    <input
                        style={{opacity: '0', position: 'absolute', width: '30px'}}
                        type='color'
                        className='oe-form-field__control'
                        value={props.normalizedValue || ''}
                        onChange={props.onChange}
                    />
                    <ColorWheelIconSvg/>
                </label>
            </div>
            {props.validationError && <span className='oe-form-field__error'>{props.validationError}</span>}
        </div>
    );
});
